import { createContext, useContext } from "react";

interface AssistantPanelContextValue {
  panelOpen: boolean;
  openPanel: () => void;
  closePanel: () => void;
}

export const AssistantPanelContext = createContext<AssistantPanelContextValue | undefined>(undefined);

export const useAssistantPanel = (): AssistantPanelContextValue => {
  const context = useContext(AssistantPanelContext);
  if (context === undefined) {
    throw new Error("useAssistantPanel must be used within an AssistantProvider");
  }
  return context;
};
